import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const CollectionsReducer = CreateGenericReducer(constructs.collection);
